import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API, axios } from '../../utils/api';
import { MESI } from '../../utils/agenda';
import { euro } from '../../utils/scheda';
import { usePersone } from '../staff/Persone';
import Icona from '../cliente/Icone';
import AzioniVisita, { MOTIVI_ANNULLA } from '../staff/AzioniVisita';
import { visitaDa } from '../../utils/visite';
import { DisponibilitaStaff } from './comuni';

// Scheda "Visite" della scheda cliente: le richieste da fissare (con la disponibilità del cliente e "Fissa"), poi le
// visite con la foto e il titolo completo dell'immobile, prezzo, m², agenzia, orario e chi accompagna, l'esito del
// cliente con la sua frase e le sue foto, Sposta / Annulla per quelle in programma. Sotto, la griglia della disponibilità.

// Le parole corte con cui il motivo si legge dentro una riga («non fa per lui: prezzo, zona»). Sono corte apposta:
// l'elenco per scegliere (utils/percorso.js) ha le frasi intere. Un test controlla che ci siano tutte le chiavi.
export const MOTIVI_VISITA = {
  prezzo: 'prezzo', zona: 'zona', stato: "stato dell'immobile", luce: 'luce, rumore o esposizione',
  spese: 'spese', metratura: 'spazi o disposizione', piano: 'piano o accessibilità',
  non_disponibile: 'non più disponibile', cliente_assente: 'il cliente non si è presentato',
  agenzia_assente: "l'agenzia non si è presentata", altro: 'altro',
};
const quante = (n, uno, tanti) => `${n} ${n === 1 ? uno : tanti}`;

// Chi ha segnato l'esito. Il server lo salva con l'esito (`esito_da`: tipo, id, nome — backend/server.py) e l'email
// allo staff dice "Esito visita segnato da Maksym", ma le schede (cliente e immobile) leggevano "Esito del cliente"
// anche quando l'aveva segnato lo staff dalla card dell'agenda. Gli esiti vecchi, senza il campo, restano del
// cliente: prima solo lui poteva darli dall'app (è la stessa regola di "Dai clienti", backend/oggi.py).
export const etichettaEsito = (visita = {}) => {
  const da = visita.esito_da;
  const tipo = String(da?.tipo || '').trim().toLowerCase();
  if (!da || !tipo || tipo === 'cliente') return 'Esito del cliente';
  const nome = String(da.nome || '').trim();
  return nome ? `Esito segnato da ${nome}` : 'Esito segnato dallo staff';
};

// Le foto della visita si leggono con il login (sono private come i documenti)
export const FotoVisita = ({ visitaId, fotoId }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u = null;
    axios.get(`${API}/visite/${visitaId}/foto/${fotoId}`, { responseType: 'blob' }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => {});
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [visitaId, fotoId]);
  return url ? <a href={url} target="_blank" rel="noopener noreferrer"><img src={url} alt="Foto del cliente" /></a> : null;
};

const TabVisite = ({ cliente, visite, immobili, apri, onFatto }) => {
  const { perId } = usePersone();
  const [disp, setDisp] = useState('');
  useEffect(() => { axios.get(`${API}/clienti/${cliente.id}/disponibilita`).then((r) => setDisp(r.data.riassunto || '')).catch(() => {}); }, [cliente.id]);
  const richieste = immobili.filter((i) => i.visita_richiesta && i.stato_attivita !== 'scartato');
  const ordinate = [...visite].sort((a, b) => String(b.data_visita).localeCompare(String(a.data_visita)));
  const fatte = visite.filter((v) => v.esito_visita || v.effettuata).length;
  const inProgramma = visite.filter((v) => !v.annullata && !v.esito_visita && !v.effettuata && v.data_visita && new Date(v.data_visita) > new Date()).length;
  return (
    <>
    <section className="card r">
      <div className="ttl"><div className="i g"><Icona nome="calendario" /></div><h2>Visite <small>{[quante(fatte, 'fatta', 'fatte'), inProgramma ? `${inProgramma} in programma` : null, quante(richieste.length, 'richiesta', 'richieste')].filter(Boolean).join(' · ')}</small></h2>
        <button type="button" className="btn sm p" onClick={() => apri('visita')}>+ Fissa visita</button></div>
      <div className="vis">
        {!visite.length && !richieste.length && <p className="vuoto">Nessuna visita.</p>}
        {richieste.map((i) => (
          <div key={`r-${i.id}`}>
            <div className="h">—<small>richiesta</small></div>
            {i.immagine_url ? <img className="im" src={i.immagine_url} alt="" /> : <div className="im" />}
            <div style={{ minWidth: 0 }}><h4>{i.titolo || i.indirizzo}</h4>
              <div className="m">{[euro(i.prezzo) && <b key="p">{euro(i.prezzo)}</b>, i.superficie, i.agenzia_info?.nome || i.agenzia, 'chiesta dal cliente'].filter(Boolean).reduce((acc, x, n) => (n ? [...acc, ' · ', x] : [x]), [])}</div>
              <div className="m">Libero: {disp ? <b>{disp}</b> : 'disponibilità non indicata'}{i.visita_richiesta.nota ? ` · “${i.visita_richiesta.nota}”` : ''}</div></div>
            <button type="button" className="btn sm p" onClick={() => apri('visita', i.id)}>Fissa</button>
          </div>
        ))}
        {ordinate.map((v) => {
          const d = v.data_visita ? new Date(v.data_visita) : null;
          const chi = perId[v.accompagna_id];
          const esito = v.esito_visita === 'positivo' ? <b style={{ color: 'var(--ok)' }}>ci piace</b> : v.esito_visita === 'negativo' ? <b style={{ color: 'var(--bad)' }}>non fa per lui</b> : null;
          return (
            <div key={v.id} data-testid={`visita-${v.id}`}>
              <div className="h">{d ? d.getDate() : '—'}<small>{d ? MESI[d.getMonth()].slice(0, 3) : ''}</small></div>
              {v.immobile_immagine_url ? <img className="im" src={v.immobile_immagine_url} alt="" /> : <div className="im" />}
              <div style={{ minWidth: 0 }}>
                <h4>{v.immobile_titolo}</h4>
                <div className="m">{[euro(v.immobile_prezzo) && <b key="p">{euro(v.immobile_prezzo)}</b>, v.immobile_superficie, v.immobile_agenzia,
                  d ? `${d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}${chi ? ` con ${chi.nome}` : ''}` : null].filter(Boolean).reduce((acc, x, n) => (n ? [...acc, ' · ', x] : [x]), [])}</div>
                <div className="m">{v.annullata ? <b style={{ color: 'var(--bad)' }}>Annullata{v.motivo_annullamento ? ` · ${(MOTIVI_ANNULLA.find((m) => m[0] === v.motivo_annullamento) || [])[1] || v.motivo_annullamento}` : ''}{v.nota_annullamento ? ` · “${v.nota_annullamento}”` : ''}</b>
                  : esito ? <>{etichettaEsito(v)}: {esito}{(v.motivi || []).length ? ` · ${v.motivi.map((m) => MOTIVI_VISITA[m] || m).join(', ')}` : ''}{v.note_esito ? ` · “${v.note_esito}”` : ''}</> : d && d > new Date() ? 'In programma' : 'Esito non ancora dato'}</div>
                {(v.foto || []).length > 0 && <div className="th">{v.foto.map((f) => <FotoVisita key={f.id} visitaId={v.id} fotoId={f.id} />)}</div>}
              </div>
              <div className="azioni-visita">
                {!v.annullata && !v.esito_visita && d && d > new Date() && (
                  <AzioniVisita visita={visitaDa({ id: v.id, data_visita: v.data_visita, durata: v.durata_minuti, accompagna_id: v.accompagna_id }, v.immobile_id)}
                    cliente={cliente} onFatto={onFatto} />
                )}
                <Link className="btn sm" to={`/immobili/${v.immobile_id}`}>Apri</Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
    <DisponibilitaStaff clienteId={cliente.id} nome={cliente.nome} onCambia={(r) => setDisp(r.riassunto || '')} />
    </>
  );
};

export default TabVisite;
